/* unplugin-vue-components disabled */import script from "./lectureEndCardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./lectureEndCardNew.vue?vue&type=script&setup=true&lang=js"

import "./lectureEndCardNew.vue?vue&type=style&index=0&id=92306074&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92306074"]])

export default __exports__